import { FullHeightCalculatorHOC, HoloHelmet } from 'common-js/components';
import { type FC } from 'react';
import SimSubMenu from 'sims/components/SubMenu';
import ActivityPanel from './ActivityPanel';

const Activity: FC = () => (
  <>
    <HoloHelmet title="Activity history" />
    <SimSubMenu />
    <FullHeightCalculatorHOC accountForDrawer backgroundColor="#F2F3F5">
      <div className="container">
        <div className="Activity">
          <ActivityPanel />
        </div>
      </div>
    </FullHeightCalculatorHOC>
  </>
);

export default Activity;
